import { Route } from "react-router-dom";
import QRList from "../pages/QRList";
import ProtectedEbdaEduRoute from "../components/ProtectedEbdaEduRoute";
import EbdaEduTms from "../pages/EbdaEduTms";
import EbdaEduTmsMyTasks from "../pages/EbdaEduTmsMyTasks";
import EbdaEduTmsAddTask from "../pages/EbdaEduTmsAddTask";
import EbdaEduTmsEditTask from "../pages/EbdaEduTmsEditTask";
import BulkData from "../pages/BulkData";
import IEESCustomQRCodes from "components/IEES/IEESCustomQRCodes";
import EbdaEduAdminPanel from "pages/ebdaedu/EbdaEduAdminPanel";
import EbdaEduWatomsTrainerRegistrations from "pages/ebdaedu/EbdaEduWatomsTrainerRegistrations";
import ViewCheckInOut from "pages/ViewCheckInOut";
import EbdaEduWatomsTraineesRegistrations from "pages/ebdaedu/EbdaEduWatomsTraineeRegistrations";
import EbdaEduWatomsCourseManagement from "pages/ebdaedu/EbdaEduWatomsCourseManagement";
import ViewTraineeAttendance from "pages/watoms/ViewTraineeAttendance";
import WatomsEvaluateManagers from "pages/WatomsEvaluateManagers";
import EbdaEduWatomsWorkshopReport from "pages/ebdaedu/EbdaEduWatomsWorkshopReport";
import EbdaEduNewOrg from "pages/ebdaedu/EbdaEduNewOrg";
import EbdaEduWatomsVtcPerformanceReport from "pages/ebdaedu/EbdaEduWatomsVtcPerformanceReport";
import WabysBulkStudents from "pages/ebdaedu/WabysBulkStudents";
import WabysUserImageUpload from "pages/ebdaedu/WabysUserImageUpload";
import WabysAdminLogin from "../pages/admin/WabysAdminLogin";
import WabysAdminMain from "pages/admin/WabysAdminMain";
import WabysAdminUserRole from "pages/admin/WabysAdminUserRole";

export const WabysAdminRoutes = () => [
    <Route key="Wabys Admin login" path="/admin/login" element={<WabysAdminLogin />} />,
    <Route key="Wabys Admin main page" path="/admin" element={
        <ProtectedEbdaEduRoute>
            <WabysAdminMain />
        </ProtectedEbdaEduRoute>
    } />,
    // TMS ENDPOINTS
    <Route key="Wabys Admin TMS" path="/admin/tms" element={
        <ProtectedEbdaEduRoute>
            <EbdaEduTms />
        </ProtectedEbdaEduRoute>
    } />,
    <Route key="IEES TMS my tasks" path="/admin/tms/my-tasks" element={
        <ProtectedEbdaEduRoute>
            <EbdaEduTmsMyTasks />
        </ProtectedEbdaEduRoute>
    } />,
    <Route key="IEES TMS add task" path="/admin/tms/add-task" element={
        <ProtectedEbdaEduRoute>
            <EbdaEduTmsAddTask />
        </ProtectedEbdaEduRoute>
    } />,
    <Route key="IEES TMS edit task" path="/admin/tms/edit/:id" element={
        <ProtectedEbdaEduRoute>
            <EbdaEduTmsEditTask />
        </ProtectedEbdaEduRoute>
    } />,
    // ADMIN PANEL ENDPOINTS
    <Route key="Wabys ADMIN PANEL" path="/admin/admin-panel" element={
        <ProtectedEbdaEduRoute>
            <EbdaEduAdminPanel />
        </ProtectedEbdaEduRoute>
    } />,
    <Route key="IEES ADMIN PANEL Watoms Trainers Registrations" path="/admin/admin-panel/view-trainer-registrations" element={
        <ProtectedEbdaEduRoute>
            <EbdaEduWatomsTrainerRegistrations />
        </ProtectedEbdaEduRoute>
    } />,
    <Route key="IEES ADMIN PANEL Watoms trainees registrations" path="/admin/admin-panel/view-trainees-registrations" element={
        <ProtectedEbdaEduRoute>
            <EbdaEduWatomsTraineesRegistrations />
        </ProtectedEbdaEduRoute>
    } />,
    <Route key="IEES ADMIN PANEL Watoms Course Management" path="/IaEES/admin-panel/watoms-course-management" element={
        <ProtectedEbdaEduRoute>
            <EbdaEduWatomsCourseManagement />
        </ProtectedEbdaEduRoute>
    } />,
    <Route key="IEES ADMIN PANEL watoms trainee attendance view" path="/admin/admin-panel/view-trainee-attendance" element={
        <ProtectedEbdaEduRoute>
            <ViewTraineeAttendance />
        </ProtectedEbdaEduRoute>
    } />,
    <Route key="IEES ADMIN PANEL watoms evaluate managers" path="/admin/admin-panel/evaluate/managers" element={
        <ProtectedEbdaEduRoute>
            <WatomsEvaluateManagers />
        </ProtectedEbdaEduRoute>
    } />,
    <Route key="IEES ADMIN PANEL watoms workshop report" path="/admin/admin-panel/workshop-report" element={
        <ProtectedEbdaEduRoute>
            <EbdaEduWatomsWorkshopReport />
        </ProtectedEbdaEduRoute>
    } />,
    <Route key="IEES ADMIN PANEL Ebda Edu checkIns" path="/admin/admin-panel/checkIns" element={
        <ProtectedEbdaEduRoute>
            <ViewCheckInOut />
        </ProtectedEbdaEduRoute>
    } />,
    <Route key="IEES ADMIN PANEL Watoms Vtc Performance Report" path="/admin/admin-panel/watoms-vtc-performance-report" element={
        <ProtectedEbdaEduRoute>
            <EbdaEduWatomsVtcPerformanceReport />
        </ProtectedEbdaEduRoute>
    } />,
    <Route key="IEES ADMIN PANEL New Organizations" path="/admin/create-organization" element={
        <ProtectedEbdaEduRoute>
            <EbdaEduNewOrg />
        </ProtectedEbdaEduRoute>
    } />,
    <Route key="IEES employees qr code" path="/admin/qrcodes" element={
        <ProtectedEbdaEduRoute>
            <QRList />
        </ProtectedEbdaEduRoute>
    } />,
    <Route key="IEES ADMIN PANEL BULK STUDENTS" path="/admin/bulk-students" element={
        <ProtectedEbdaEduRoute>
            <WabysBulkStudents />
        </ProtectedEbdaEduRoute>
    } />,
    <Route key="IEES ADMIN PANEL USER IMAGE UPLOAD" path="/admin/user-image-upload" element={
        <ProtectedEbdaEduRoute>
            <WabysUserImageUpload />
        </ProtectedEbdaEduRoute>
    } />,
    <Route key="bulk data" path="/bulk-data" element={
        <ProtectedEbdaEduRoute>
            <BulkData />
        </ProtectedEbdaEduRoute>
    } />,
    <Route key="IEES Custom QR Codes" path="/admin/qrcodes/custom" element={
        <ProtectedEbdaEduRoute>
            <IEESCustomQRCodes />
        </ProtectedEbdaEduRoute>
    } />,
    <Route key="IEES User Role Config" path="/admin/user-role" element={
        <ProtectedEbdaEduRoute>
            <WabysAdminUserRole />
        </ProtectedEbdaEduRoute>
    } />,
];